<div class="onbo-guide" *ngIf="guide; else fallbackTpl">
  <h4 class="onbo-guide__title">🎓 <span [innerHTML]="html(guide.title)"></span></h4>

  <div class="onbo-guide__steps">
    <div class="onbo-guide__step" *ngFor="let step of guide.steps">
      <div class="onbo-guide__step-num">{{ step.number }}</div>
      <div class="onbo-guide__step-body">
        <strong [innerHTML]="html(step.title)"></strong>
        <p [innerHTML]="html(step.text)"></p>
        <img *ngIf="step.media"
             [src]="step.media.url"
             [alt]="step.media.alt"
             class="onbo-guide__media"
             [class.gif]="step.media.type === 'gif'"
             loading="lazy" />
      </div>
    </div>
  </div>

  <div class="onbo-guide__tip" *ngIf="guide.tip">
    💡 <span [innerHTML]="html(guide.tip)"></span>
  </div>
</div>

<ng-template #fallbackTpl>
  <pre *ngIf="fallbackRaw" style="font-size:12px;color:#999">{{ fallbackRaw }}</pre>
</ng-template>
